import './index.css'

const ProjectsItem = props => {
  const {data} = props
  const {name, url, image} = data
  return (
    <li className="project-card">
      <img src={image} alt="project" className="project-image" />
      <p className="project-name">{name}</p>
      <a href={url} className="link">
        <p>{url}</p>
      </a>
    </li>
  )
}

export default ProjectsItem
